class LookAndStyle {
    static get IsNarrowAlert() { return window.innerWidth < 1600; }
    static get GraphWidth() { return window.innerWidth < 1600 ? 500 : 600; }
}
LookAndStyle.RADIUS_MPOINT_MARKER = 5;
LookAndStyle.RADIUS_HOVER_CIRCLE = 60;
export default LookAndStyle;
